import type { UseCase } from '@/core/shared'
import type { AuthRepository } from '../domain'

export const doSignIn: UseCase<AuthRepository, 'signIn'> = repository => {
  return async signIn => {
    return await repository.signIn(signIn)
  }
}
